/** The email-account precedence shared by pickers and server class repairs. */
interface LinkedJrStaffAccount {
  uid: string;
  role: string;
  status: string;
  studentId?: string | null;
  jrStaffPromoted?: boolean;
}
export function jrStaffEmailAccounts<T extends LinkedJrStaffAccount>(users: readonly T[], studentId: string): T[] {
  if (!studentId) return [];
  return users.filter(user => user.studentId === studentId && user.status === 'active'
    && user.role === 'ensemble' && user.jrStaffPromoted !== true)
    .sort((a, b) => a.uid.localeCompare(b.uid));
}
